import cn from "classnames";
import { type FC } from "react";
import EllipsisPopupButton from "components/buttons/ellipsisPopupButton/EllipsisPopupButton";
import { RemoveLinkButton } from "components/buttons/linkButtons";

export interface Props {
  id: number;
  disabled: boolean;
  hasLicensingPermissions: boolean;
  onRemoveLicenseClick: (id: number) => void;
}

export const PeoplePackMenu: FC<Props> = (props: Props) => {
  const { id, disabled, hasLicensingPermissions, onRemoveLicenseClick } = props;

  const handleMenuOpen = (e: React.MouseEvent) => {
    e.stopPropagation();
    e.preventDefault();
  };

  const removeLicenseButton = (
    <RemoveLinkButton
      key={cn("RemoveLicenseButton-", id)}
      onClick={() => {
        onRemoveLicenseClick(id);
      }}
    />
  );

  if (hasLicensingPermissions) {
    return (
      <div onClick={handleMenuOpen}>
        <EllipsisPopupButton disabled={disabled} circle>
          {[removeLicenseButton]}
        </EllipsisPopupButton>
      </div>
    );
  }

  return (
    <div data-testid="disabledPeopleCardEllipsis" onClick={handleMenuOpen}>
      <EllipsisPopupButton disabled circle>
        {[]}
      </EllipsisPopupButton>
    </div>
  );
};
